import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import ProductCardSlider from "../homePage/card/ProductCardSlider";

const products = [{
    "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
    "img": "./assets/sample-image/mouse.png",
    "price": "۲،۷۶۰،۰۰۰ ",
    "color_range_1": "#192B3B",
    "color_range_2": "#F5F8FA",
    "color_range_3": "#1473E6",
    "link_product": "s",
    "type_card": "blue",
    "id": 1_2
},
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/mouse.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "s",
        "type_card": "blue",
        "id": 2_2
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/mouse.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "s",
        "type_card": "blue",
        "id": 3_2
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/mouse.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "s",
        "type_card": "blue",
        "id": 4_2
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/mouse.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "s",
        "type_card": "blue",
        "id": 5_2
    },
    {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/mouse.png",
        "price": "۲،۷۶۰،۰۰۰ ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "link_product": "s",
        "color_range_3": "#1473E6",
        "type_card": "blue",
        "id": 6_2
    }];
const BrandHeadphone = () => {
    return (
        <div className="brand-headphone-wrapper xmt-8 xmt-lg-12">
            <div className="container">
                <div className="title">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                            <h2 className="text">
                                انواع هدفون
                            </h2>
                        </div>
                        <div className="more">
                            <span className="d-none d-sm-inline"><a href="#">بیشتر</a></span>
                            <a href="#"><IconName name="chevron_left" className="icon"/></a>
                        </div>
                    </div>
                </div>
                <ProductCardSlider data={products} bgPagination="blue"/>
            </div>
        </div>
    );
};

export default BrandHeadphone;
